export default __webpack_public_path__ + "static/media/wrinklesActive.c18e828d.svg";